import {
  Button,
  Card,
  CardContent,
  Typography,
  Snackbar,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AccountCircle as GoogleIcon } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import { DelayedLinearProgress } from 'components';
import { triggerGoogleLogin } from 'lib/Helper/Auth';
import * as React from 'react';

const useStyles = makeStyles((theme) => ({
  loginBtn: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  caption: {
    display: 'block',
    marginTop: theme.spacing(1),
  },
  branding: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
  form: {
    pointerEvents: (props: { loading: boolean }) =>
      props.loading ? 'none' : 'auto',
  },
}));

export const LoginForm: React.FC = () => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const classes = useStyles({ loading });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await triggerGoogleLogin();
    } catch (err) {
      setError('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Card>
        <form onSubmit={handleSubmit} className={classes.form}>
          <CardContent>
            <Button
              type="submit"
              size="medium"
              color="primary"
              disabled={loading}
              variant="contained"
              className={classes.loginBtn}
              fullWidth
              startIcon={<GoogleIcon />}
            >
              Sign in with your organisation account
            </Button>
            <Typography
              variant="caption"
              color="textSecondary"
              align="center"
              className={classes.caption}
            >
              Having trouble? Contact insights@konnekttalexio.com for assistance
            </Typography>
          </CardContent>
          <DelayedLinearProgress variant="query" loading={loading} />
        </form>
      </Card>
      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={() => setError(null)}
      >
        <Alert onClose={() => setError(null)} severity="error">
          {error}
        </Alert>
      </Snackbar>
    </>
  );
};
